import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";
import Edit from "../../assets/Edit.svg";
import { checkPermission } from "../../Utils/permissionHelper";

const SessionHistoryTable = ({ additionalData, showDrawer, handleCloseSessionClick,onRowClick }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )


  const openOrderList = (id) => {
    // console.log("CREDIT CUS TOME id", id);

    navigate(`/customerCreditOrder?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  const formatAddress = (address, t) => {
  if (!address) return "";

  const parts = [];

  if (address.add_field_1) {
    parts.push(
      `${
        address.name === "Villa"
          ? t("Villa No.-")
          : address.name === "Apartment"
          ? t("Building-")
          : address.name === "Office"
          ? t("Company-")
          : ""
      } ${address.add_field_1}`
    );
  }

  if (address.add_field_2) {
    parts.push(
      `${
        address.name === "Villa"
          ? t("Group No.-")
          : address.name === "Apartment"
          ? t("Apartment No.-")
          : address.name === "Office"
          ? t("Floor-")
          : ""
      } ${address.add_field_2}`
    );
  }

  if (address.add_field_3) {
    parts.push(
      `${
        address.name === "Villa"
          ? t("Street-")
          : address.name === "Apartment"
          ? t("Floor-")
          : address.name === "Office"
          ? t("Building-")
          : ""
      } ${address.add_field_3}`
    );
  }

  if (address.add_field_4) {
    parts.push(address.add_field_4);
  }

  return parts.join(", ");
};

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

const columns = useMemo(
  () => [
    {
      Header: t("Cashier Name"),
      accessor: "user_name",
      width: "18%",
      Cell: ({ row }) => (
        <div className="text-start">
          <div>{row.original.user_name}</div>
          {allStores && row.original?.last_sessions?.[0]?.store_name && (
            <div className="text-xs text-gray-400">
              {row.original.last_sessions[0].store_name}
            </div>
          )}
        </div>
      ),
    },
    {
      Header: t("Sessions"),
      accessor: "session_count",
      width: "8%",
    },
    {
      Header: t("Orders"),
      accessor: "order_count",
      width: "8%",
    },
    {
      Header: t("Last Opening Date"),
      accessor: (row) => row?.last_sessions?.[0]?.start_at || "—",
      width: "14%",
    },
    {
      Header: t("Last Closing Date"),
      accessor: (row) => row?.last_sessions?.[0]?.stop_at || "—",
      width: "14%",
    },
    {
      Header: t("Current Sales"),
      accessor: (row) =>
        `EGP ${Number(
          row?.last_sessions?.[0]?.total_sales || 0
        ).toFixed(2)}`,
      width: "12%",
    },
    {
      Header: t("Status"),
      accessor: "status",
      width: "8%",
      Cell: ({ row }) => {
        const isOpened =
          row.original?.last_sessions?.[0]?.session_state === "opened";

        return (
          <span
            className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${
              isOpened
                ? "bg-yellow-100 text-yellow-800"
                : "bg-green-100 text-green-800"
            }`}
          >
            {isOpened ? t("Opened") : t("Closed")}
          </span>
        );
      },
    },
    {
      Header: t("History"),
      accessor: "history",
      disableSortBy: true,
      width: "9%",
      Cell: ({ row }) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            showDrawer(row.original);
          }}
          className="border border-primaryBlue text-primaryBlue text-xs font-semibold px-3 py-1.5 rounded-lg"
        >
          {t("History")}
        </button>
      ),
    },
    {
      Header: t("Actions"),
      accessor: "actions",
      disableSortBy: true,
      width: "9%",
      Cell: ({ row }) => {
        const session = row.original?.last_sessions?.[0];

        return session?.session_state === "opened" ? (
          <button
            onClick={(e) => {
              e.stopPropagation();

              if (checkPermission("/pos/sessionHistory", isGinne)) {
                handleCloseSessionClick(
                  session?.session_id,
                  session?.access_token
                );
              }
            }}
            className="bg-primaryBlue text-white text-xs font-semibold px-3 py-1.5 rounded-lg"
          >
            {t("Close Session")}
          </button>
        ) : null;
      },
    },
  ],
  [t, allStores]
);


 const {
  headerGroups,
  prepareRow,
  rows,
} = useTable(
  {
    columns,
    data,
  },
  useSortBy,
  useRowSelect
);




 


  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                            <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                                                                 {column.render("Header")}
                                                                                                                                 {column.canSort && (
                                                                                                                                   <span className="ms-1">
                                                                                                                                     {column.isSorted ? (
                                                                                                                                       column.isSortedDesc ? (
                                                                                                                                         <img
                                                                                                                                           src={Vectorsorting}
                                                                                                                                           style={{
                                                                                                                                             minHeight: 10,
                                                                                                                                             minWidth: 10,
                                                                                                                                           }}
                                                                                                                                           alt="vector"
                                                                                                                                         />
                                                                                                                                       ) : (
                                                                                                                                         <img
                                                                                                                                           className="rotate-180"
                                                                                                                                           src={Vectorsorting}
                                                                                                                                           alt="vector"
                                                                                                                                         />
                                                                                                                                       )
                                                                                                                                     ) : (
                                                                                                                                       // 👇 Show a neutral icon when column is not sorted
                                                                                                                                       <img
                                                                                                                                         src={Vectorsorting}
                                                                                                                                         alt="sortable"
                                                                                                                                         style={{
                                                                                                                                           minHeight: 10,
                                                                                                                                           minWidth: 10,
                                                                                                                                           opacity: 0.3,
                                                                                                                                         }}
                                                                                                                                       />
                                                                                                                                     )}
                                                                                                                                   </span>
                                                                                                                                 )}
                                                                                                                               </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
    height: "calc(100vh - 200px)",
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {rows.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                          // onClick={() => openOrderList(row.original.customer_id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {rows.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </>
        )}
      </div>
    </>
  );
};

export default SessionHistoryTable;
